<div class="text-center  instructionheading mt-4">
  <h4>
    INSTRUCTIONS FOR SUBMITTING YOUR THIRD-PARTY PAYER CLAIM FORM<br />
    FOR THE SANDOZ, APOTEX, HERITAGE, AND SUN/TARO SETTLEMENTS
  </h4>
</div>
<br />
<div class="container" style="border:1px solid #bebaba">
  <br />
  <div class="row">
    <div class="col-md-12">

      A Third-Party Payer (“TPP”) or its authorized agent may complete this claim form if it is a member of any of the following settlement classes:
      the EPP Sandoz Settlement Class, the EPP Apotex Settlement Class, the EPP Heritage Settlement Class, or the EPP Sun/Taro Settlement Class. The
      claim submission deadline is <b>November 9, 2026</b>. If both a Settlement Class Member and its authorized agent submit a claim form, the Claims
      Administrator will only consider the Settlement Class Member’s claim form. The Claims Administrator may request supporting documentation in
      addition to the documentation and information requested below. The Claims Administrator may reject a claim if the TPP Settlement Class Member
      or its authorized agent does not provide all requested documentation in a timely manner.<br /><br />

      If you are a Settlement Class Member submitting a claim form on your own behalf, you must provide the information requested in “<b>
        Section A
        – INSURER OR SELF-INSURED SETTLEMENT CLASS MEMBER ONLY,
      </b>” in addition to the other information requested by this claim form.<br /><br />

      If you are an <b>authorized agent</b> of one or more Settlement Class Members, you must provide the information requested in “<b>
        Section B
        – AUTHORIZED AGENT ONLY,
      </b>” in addition to the other information requested by this claim form. <b>
        Do not submit a claim form on behalf of
        any Settlement Class Member unless that Settlement Class Member provided prior authorization for you to submit the claim form
      </b>.<br /><br />

      If you are submitting a claim form only as an authorized agent of one or more Settlement Class Members, you may submit a separate claim form
      for each Settlement Class Member OR you may submit one claim form for all such Settlement Class Members if you provide the information required
      for each Settlement Class Member on whose behalf you are submitting the form.<br /><br />

      If you are submitting claim forms both on your own behalf as a Settlement Class Member AND as an authorized agent on behalf of one or more
      Settlement Class Members, you should submit one claim form for yourself, where you complete Section A, and another claim form as an authorized
      agent for the other Settlement Class Member(s), where you complete Section B.<br /><br />

      To qualify to receive a payment from any of the Settlements, you must complete and submit this claim form either on paper
      (click <a href="../../../assets/Docs/2026/EPP TPP Claim Form 9.18.26.pdf" target="_blank">HERE</a> to download a printable claim form and instructions on how to file a paper claim) or electronically
      on the next page, and you may need to provide certain requested documentation to substantiate your claim.<br /><br />

      If you do not complete and submit the claim form so that it is postmarked or filed online by <b>November 9, 2026</b>, you will not receive
      any payment from any of the Settlements. Submitting this claim form does not ensure that you will share in any payments related to the
      Settlements. If the Claims Administrator rejects or reduces your claim, you may follow the dispute resolution process described in Section
      D of the form.<br /><br /><br />

      <h5 style="font-weight:bold;text-decoration:underline; text-align:left">ELIGIBILITY REQUIREMENTS</h5><br />

      To be eligible to file a claim form and receive a cash distribution, you must be a member of a Settlement Class. <br /><br />

      <b>The Settlement Classes include:</b><br /><br />

      <p class="row" style="margin-left: 7%; margin-right: 7%">
        All persons and entities in each of the 50 United States (except Indiana and Ohio), as well as the District of Columbia, Puerto Rico,
        and the U.S. Virgin Islands, that indirectly purchased, paid, and/or provided reimbursement for some or all of the purchase price for
        any Named Generic Drugs, other than for resale, from May 1, 2009, through December 31, 2019.<br /><br />
      </p>

      <div class="container" style="border:3px solid #ca0b0b; font-weight:bold">
        Click <a href="../../../assets/Docs/2026/Drug List for Claim Form (2026-07-30).pdf" target="_blank">HERE</a> for the list of Named Generic Drugs.
      Click <a href="../../../assets/Docs/2026/NDC List v3.xlsx" target="_blank">HERE</a> for a list of National Drug Code (“NDC”) numbers associated with those drugs.
      </div><br /><br />

      Several groups are not eligible to file a claim form or receive a cash distribution from the Settlements, even if they otherwise meet the
      definition above. <b>The EPP Settlement Classes do <u>not</u> include</b>:<br /><br />

      <p class="row" style="margin-left: 7%; margin-right: 7%">
        •	Defendants and their officers, directors, management, employees, subsidiaries, and affiliates;<br />
        •	Federal governmental entities;<br />
        •	Persons or entities who only purchased Named Generic Drugs for purposes of resale or directly from Defendants;<br />
        •	Fully insured employers to the extent that they use fully-insured plans (i.e., employers that purchased insurance covering 100% of their reimbursement obligation to members); and<br />
        •	Pharmacy benefit managers.<br /><br />
      </p>

      Click <a href="../../../assets/Docs/2026/List of Defendants.pdf" target="_blank">HERE</a> for the list of Defendants.<br /><br />

      <b>The EPP Heritage Settlement Class has additional exclusions. That Settlement Class does <u>not</u> include:</b><br /><br />

      <p class="row" style="margin-left: 7%; margin-right: 7%">

        •	State governmental entities (but the Settlement Class does include cities, towns, municipalities, counties, and other local
        governmental entities with self-funded prescription drug plans);<br />
        •	Purchases made in the U.S. Virgin Islands; and<br />
        •	Purchases made before March 1, 2011, or after April 1, 2019.<br /><br />
      </p>

      <b>The EPP Sandoz Settlement Class and EPP Sun/Taro Settlement Class have additional exclusions. Those two Settlement Classes do <u>not</u> include:</b><br /><br />

      <p class="row" style="margin-left: 7%; margin-right: 7%">

        •	Governmental Medicaid agencies and private Medicaid managed care organizations;<br />
        •	Judges assigned to this case and any members of their immediate families; and<br />
        •	State governmental entities (but the classes do include cities, towns, municipalities, counties, and other local governmental entities with self-funded prescription drug plans).<br /><br />
      </p>

      <b>The EPP Apotex Settlement Class has additional exclusions. That Settlement Class does <u>not</u> include:</b><br /><br />

      <p class="row" style="margin-left: 7%; margin-right: 7%">

        •	State Entities identified by the Attorneys General in Appendix B to the Apotex Settlement Agreement (available at www.GenericDrugsEndPayerSettlement.com); and<br /><br />
        •	All State Entities of California, Connecticut, Florida, Illinois, Maine, Oregon, Pennsylvania, Washington, and Wyoming (but the Settlement Class does include cities, towns,
        municipalities, counties, and other local governmental entities with self-funded prescription drug plans). (Note: despite the exclusion of Illinois State Entities, Illinois
        public corporations, including public universities and health systems, are included in the Settlement Class.)<br /><br />
      </p>

      If you have purchases that meet the definition of a Settlement Class, but also have purchases
      that fall within one or more of the exclusions above, you are included in the Settlement Class only with respect to those purchases that meet the definition of the
      Settlement Class.<br /><br />

      Anyone who excluded itself from a Settlement Class—or was excluded from a Settlement Class by an authorized representative—may not share in that Settlement. <b>
        If you
        excluded yourself (or if your authorized representative excluded you) from all of the Settlement Classes, you may not file a claim. If you excluded yourself (or
        if your authorized representative excluded you) from some, but not all, of the Settlement Classes, you may file a claim, but you will not receive a distribution
        from the Settlements from which you are excluded.
      </b><br /><br /><br />


      <h5 style="font-weight:bold;text-decoration:underline; text-align:left">CLAIM INFORMATION AND DOCUMENTATION REQUIREMENTS</h5><br /><br />

      Please provide the following information to support your claim that you (or the Settlement Class Member(s) you represent) indirectly purchased, paid for, and/or
      reimbursed some or all of the purchase price for one of more Named Generic Drugs, not for resale, in any of the 50 United States (except Indiana and Ohio), the
      District of Columbia, Puerto Rico, or the U.S. Virgin Islands, from May 1, 2009, through December 31, 2019:<br /><br />

      <p class="row" style="margin-left: 7%; margin-right: 7%">

        a)	Unique patient identification number or code;<br />
        b)	NDC number (a list of eligible NDC numbers is available at the website, www.GenericDrugsEndPayerSettlement.com) – e.g., 00000-0000-00;<br />
        c)	Fill Date or Date of Service – e.g., 01/01/2016;<br />
        d)	Location (State) of Service – e.g., CA;<br />
        e)	Amount Billed (not including dispensing fee) – e.g., $40.00; and<br />
        f)	Amount Paid by TPP (you) net of co-pays, deductibles, and co-insurance – e.g., $20.00.<br /><br />

      </p>

      Do not include any payments for drugs purchased directly from Defendants or purchased for purposes of resale.<br /><br />

      If you are submitting a claim form on behalf of multiple Settlement Class Members, also provide the following information for each purchase or reimbursement:<br /><br />

      <p class="row" style="margin-left: 7%; margin-right: 7%">

        g)	Plan or Group Name; and<br />
        h)	Plan or Group FEIN.<br /><br />


      </p>

      In addition, for each year of the Settlement Class period, please provide the following information:<br /><br />

      <p class="row" style="margin-left: 7%; margin-right: 7%">


        <u>If you are an insurer:</u>
        a)	Number of Covered Lives for Fully-Insured Prescription Drug Benefit Plans that covered Drugs at Issue; and<br />
        b)	Number of Covered Lives for clients/customers for whom you provided Administrative Services Only for Prescription
        Drug Benefit Plans that covered Drugs at Issue and on whose behalf you are filing a claim.<br /><br />

        <u>If you are a self-insured entity:</u>
        Number of Covered Lives for Self-Insured Prescription Drug Benefit Plans that covered Drugs at Issue.


      </p>

      For your convenience, exemplar spreadsheets are available for download <a href="../../../assets/Docs/2026/Template 1 TPP Claims Data Submission 2026-04-29 fkb.xlsx" target="_blank">HERE</a> and <a href="../../../assets/Docs/2026/Template 2 TPP Covered Lives Data Submission 2026-05-13 fkb.xlsx" target="_blank">HERE</a>. Please use this format and provide as much of the requested information as possible. A list
      of the NDC numbers that the Claims Administrator will consider is available for download <a href="../../../assets/Docs/2026/NDC List v3.xlsx" target="_blank">HERE</a>. If possible, please provide electronic data in Microsoft Excel, ASCII flat file pipe “|”,
      tab-delimited, or fixed-width format.<br /><br />

      Please keep all transaction data and any other documents supporting your claim in case the Claims Administrator requests them later. If, after your claim is
      audited, the Claims Administrator determines that you did not provide sufficient documentation to substantiate your claim, the Claims Administrator may reject
      your claim.<br /><br />

      Please contact the Claims Administrator at 1-877-316-0171 with any questions about the required claims information or documentation.<br /><br />


      <ul class="list-inline text-center mt-4">
        <li class="list-inline-item">
          <button class="btn btn-primary" [routerLink]='["/tpp-claimants"]' type="button">Next</button>
        </li>
      </ul>

    </div>
  </div>
</div>

























